/**
 * Created by Rumyantsev Daniil on 25.06.2018.
 */

import { Pipe, PipeTransform } from '@angular/core';
/*
 * Принимает дату
 * Возвращает дату в формате, который понимает Сафари
 *
 * Usage:
 *   date | safari
 */
@Pipe({name: 'safari'})
export class SafariDatePipe implements PipeTransform {


  transform(date: string): Date {

    console.log("SafariDatePipe date :", date);

    if(date == null || date == '') {
      return null;
    }

    return new Date(date.replace(/ /g, "T") + 'Z');
  }
}



// WEBPACK FOOTER //
// D:/dev/smartcityspace_git/web/frontend/src/main/frontend/src/app/pipe/safari-date.pipe.ts